import React from 'react';

type WorktreeIndicatorProps = {
    name: string | undefined;
};

const containerStyle: React.CSSProperties = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    backgroundColor: '#c92a2a',
    color: '#fff',
    textAlign: 'center',
    fontWeight: 700,
    fontSize: '12px',
    letterSpacing: '0.05em',
    padding: '4px 8px',
    pointerEvents: 'none',
    fontFamily: 'monospace',
};

export const WorktreeIndicator: React.FC<WorktreeIndicatorProps> = ({ name }) => {
    if (!name) return null;

    return (
        <div style={containerStyle} role="status" aria-label="Worktree indicator">
            worktree: {name}
        </div>
    );
};
